import { render } from "./EditRuleSet.vue?vue&type=template&id=d5ecf942&ts=true"
import script from "./EditRuleSet.vue?vue&type=script&lang=ts"
export * from "./EditRuleSet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__